module.exports = __webpack_public_path__ + "static/media/kid6.632dddfb.png";